export default class LicenseeLineRowData {
    constructor(value) {
        this.chargeType = value.chargeType[0] || "";
        this.brand = value.brand[0] || "";
        this.account = value.account[0] || "";
        this.amount = value.amount[0] || "";
        this.batchRef = value.batchRef[0] || "";
        this.chargePeriod = value.chargePeriod[0] || "";
    }
}

